// 运营管理路由
export default {
    path: 'operation',
    component: () => import('@/components/RouterView'),
    redirect: 'noRedirect',
    meta: {title: '秀动运营管理'},
    children: [
        {
            path: 'businessNotice',
            component: () => import('@/components/RouterView'),
            redirect: '/operation/businessNotice/list',
            meta: {title: '业务通告'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/operation/businessNotice/list.vue'),
                    meta: {title: '业务通告列表'}
                },
                {
                    path: 'edit/:id',
                    component: () => import('@/views/operation/businessNotice/edit.vue'),
                    meta: {title: '编辑通告'},
                    props: true
                },
                {
                    path: 'add',
                    component: () => import('@/views/operation/businessNotice/edit.vue'),
                    meta: {title: '新建通告'}
                }
            ]
        },
        {
            path: 'chatGroup',
            component: () => import('@/components/RouterView'),
            redirect: '/operation/chatGroup/list',
            meta: {title: '群组管理'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/operation/chatGroup/list.vue'),
                    meta: {title: '群组列表'}
                },
                {
                    path: 'edit/:id',
                    component: () => import('@/views/operation/chatGroup/edit.vue'),
                    meta: {title: '编辑群组'},
                    props: true
                },
                {
                    path: 'add',
                    component: () => import('@/views/operation/chatGroup/edit.vue'),
                    meta: {title: '新建群组'}
                },
                {
                    path: 'template',
                    component: () => import('@/views/operation/chatGroup/template.vue'),
                    meta: {title: '自动建群规则'}
                }
            ]
        },
        {
            path: 'music',
            component: () => import('@/components/RouterView'),
            redirect: '/operation/music/list',
            meta: {title: '歌曲资源'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/operation/music/list.vue'),
                    meta: {title: '歌曲资源列表'}
                }
            ]
        },
		{
		    path: 'lpa',
		    component: () => import('@/components/RouterView'),
		    redirect: '/operation/lpa/list',
		    meta: {title: 'LPA投票'},
		    children: [
		        {
		            path: 'list',
		            component: () => import('@/views/operation/lpa/list.vue'),
		            meta: {title: 'LPA投票'}
		        },
				{
				    path: 'setting',
				    component: () => import('@/views/operation/lpa/setting.vue'),
				    meta: {title: 'LPA榜单配置'}
				},
				{
				    path: 'votedata',
				    component: () => import('@/views/operation/lpa/votedata.vue'),
				    meta: {title: 'LPA数据'}
				}
		    ]
		},
        {
            path: 'video',
            component: () => import('@/components/RouterView'),
            redirect: '/operation/video/list',
            meta: {title: '视频资源'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/operation/video/list'),
                    meta: {title: '视频资源列表'}
                },
                {
                    path: 'task',
                    component: () => import('@/views/operation/video/task'),
                    meta: {title: '待转码视频列表'}
                },
                {
                    path: 'strategy',
                    component: () => import('@/components/RouterView'),
                    meta: {title: '付费策略'},
                    redirect: '/operation/video/strategy/list',
                    children: [
                        {
                            path: 'list',
                            component: () => import('@/views/operation/video/strategy'),
                            meta: {title: '策略列表'}
                        },
                        {
                            path: 'detail/:id',
                            name: 'strategyDetail',
                            component: () => import('@/views/operation/video/strategy/detail'),
                            meta: {title: '策略详情'},
                            props: true
                        },
                        {
                            path: 'add',
                            name: 'strategyAdd',
                            component: () => import('@/views/operation/video/strategy/detail'),
                            meta: {title: '创建策略'}
                        }
                    ]
                },
                {
                    path: 'channel',
                    component: () => import('@/components/RouterView'),
                    meta: {title: '频道管理'},
                    redirect: '/operation/video/channel/list',
                    children: [
                        {
                            path: 'list',
                            component: () => import('@/views/operation/video/channel/list'),
                            meta: {title: '频道管理列表'}
                        },
                        {
                            path: 'edit/:id',
                            name: 'channelEdit',
                            component: () => import('@/views/operation/video/channel/edit'),
                            meta: {title: '管理频道'},
                            props: true
                        },
                        {
                            path: 'add',
                            name: 'channelAdd',
                            component: () => import('@/views/operation/video/channel/edit'),
                            meta: {title: '创建频道'}
                        }
                    ]
                }
            ]
        },
        {
            path: 'startupDiagram',
            component: () => import('@/components/RouterView'),
            redirect: '/operation/startupDiagram/list',
            meta: {title: '启动图'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/operation/startupDiagram/index.vue'),
                    meta: {title: '启动图列表', activePage: '/operation/startupDiagram'}
                },
                {
                    path: 'detail/:id',
                    component: () => import('@/views/operation/startupDiagram/detail.vue'),
                    meta: {title: '启动图详情', activePage: '/operation/startupDiagram'}
                },
                {
                    path: 'add',
                    component: () => import('@/views/operation/startupDiagram/detail.vue'),
                    meta: {title: '启动图新建', activePage: '/operation/startupDiagram'}
                },
                {
                    path: 'schedule',
                    component: () => import('@/views/operation/startupDiagram/schedule'),
                    meta: {title: '启动图排期', activePage: '/operation/startupDiagram'}
                }
            ]
        },
        {
            path: 'banner',
            component: () => import('@/components/RouterView'),
            redirect: '/operation/banner/list',
            meta: {title: 'Banner管理'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/operation/banner/index.vue'),
                    meta: {title: 'Banner列表', activePage: '/operation/banner'}
                },
				{
					path: 'listcalendar',
					component: () => import('@/views/operation/banner/indexcalendar.vue'),
					meta: {title: 'Banner月历列表', activePage: '/operation/banner'}
				},
                {
                    path: 'detail/:id',
                    component: () => import('@/views/operation/banner/detail.vue'),
                    meta: {title: 'Banner详情', activePage: '/operation/banner'}
                },
				{
					path: 'addCalendar/:time',
					component: () => import('@/views/operation/banner/detail.vue'),
					meta: {title: 'Banner新建', activePage: '/operation/banner'}
				},
                {
                    path: 'add',
                    component: () => import('@/views/operation/banner/detail.vue'),
                    meta: {title: 'Banner新建', activePage: '/operation/banner'}
                }
            ]
        },
        {
            path: 'showTop',
            component: () => import('@/views/operation/showTop/index.vue'),
            meta: {title: '演出置顶'}
        },
        {
            path: 'advertis',
            component: () => import('@/components/RouterView'),
            redirect: '/operation/advertis/list',
            meta: {title: '广告管理'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/operation/advertis/index.vue'),
                    meta: {title: '广告列表', activePage: '/operation/advertis'}
                },
				{
					path: 'listcalendar',
					component: () => import('@/views/operation/advertis/indexcalendar.vue'),
					meta: {title: '广告月历列表', activePage: '/operation/advertis'}
				},
                {
                    path: 'detail/:id',
                    component: () => import('@/views/operation/advertis/detail.vue'),
                    meta: {title: '广告详情', activePage: '/operation/advertis'}
                },
                {
                    path: 'add',
                    component: () => import('@/views/operation/advertis/detail.vue'),
                    meta: {title: '广告新建', activePage: '/operation/advertis'}
                },
				{
					path: 'addAdvertis/:time',
					component: () => import('@/views/operation/advertis/detail.vue'),
					meta: {title: '广告新建', activePage: '/operation/advertis'}
				},
            ]
        },
        {
            path: 'comment',
            component: () => import('@/components/RouterView'),
            redirect: '/operation/comment/list',
            meta: {title: '评论管理'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/operation/comment/index.vue'),
                    meta: {title: '评论列表'}
                },
                {
                    path: 'detail/:id',
                    component: () => import('@/views/operation/comment/detail.vue'),
                    meta: {title: '评论详情'}
                },
                {
                    path: 'shield',
                    component: () => import('@/views/operation/comment/shield'),
                    meta: {title: '屏蔽词管理'}
                }
            ]
        },
        {
            path: 'h5Page',
            component: () => import('@/components/RouterView'),
            redirect: '/operation/h5Page/list',
            meta: {title: 'H5页面配置'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/operation/h5Page/list.vue'),
                    meta: {title: 'H5页面配置列表'}
                },
                {
                    path: 'resource/:id',
                    component: () => import('@/views/operation/h5Page/resource.vue'),
                    meta: {title: '页面元素'},
                    props: true
                }
            ]
        },
        {
            path: 'city',
            component: () => import('@/components/RouterView'),
            redirect: '/operation/city/list',
            meta: {title: '城市管理'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/operation/city/list/index.vue'),
                    meta: {title: '城市管理'}
                }
                // {
                //     path: 'resource/:id',
                //     component: () => import('@/views/operation/h5Page/resource.vue'),
                //     meta: {title: '页面元素'},
                //     props: true
                // }
            ]
        },
        {
            path: 'messagePush',
            component: () => import('@/views/operation/messagePush'),
            meta: {title: 'APP消息推送'}
        },
		
		{
		    path: 'messagePush',
		    component: () => import('@/components/RouterView'),
		    redirect: '/operation/messagePush',
		    meta: { title: 'APP消息推送'},
		    children: [
		        {
		            path: '',
		            component: () => import('@/views/operation/messagePush'),
		            meta: {title: 'APP消息推送'}
		        },
				{
				    path: 'add',
				    component: () => import('@/views/operation/messagePush/add'),
				    meta: {title: '推送官方消息'},
				    props: true
				},
		    ]
		},
        // App内升级通知
        {
            path: 'updateNotify',
            component: () => import('@/components/RouterView'),
            redirect: '/operation/updateNotify/list',
            meta: { title: 'APP版本管理'},
            children: [
                {
                    path: 'listyuemi',
                    component: () => import('@/views/operation/updateNotify/listyuemi.vue'),
                    meta: {title: 'APP版本管理-乐迷版'}
                },
				{
				    path: 'list',
				    component: () => import('@/views/operation/updateNotify/list.vue'),
				    meta: {title: 'APP版本管理-专业版'}
				},
                {
                    path: 'edit/:id/:appType',
                    component: () => import('@/views/operation/updateNotify/edit.vue'),
                    name: 'editUpdateNotify',
                    meta: {title: '管理版本'},
                    props: true
                },
                {
                    path: 'add',
                    component: () => import('@/views/operation/updateNotify/edit.vue'),
                    name: 'addUpdateNotify',
                    meta: {title: '创建版本'},
                    props: true
                }
            ]
        },
        //举报管理
        {
            path: 'accusation',
            component: () => import('@/components/RouterView'),
            redirect: '/operation/accusation',
            meta: { title: '举报管理'},
            children: [
                {
                    path: '',
                    component: () => import('@/views/operation/accusation'),
                    meta: {title: '举报管理列表'}
                },
                {
                    path: 'edit/:id',
                    component: () => import('@/views/operation/accusation/edit'),
                    meta: {title: '举报详情'},
                    props: true
                },
            ]
        },
        //indieStart 
        {
            path: 'indieStar',
            component: () => import('@/components/RouterView'),
            redirect: '/operation/indieStar/vote',
            meta: { title: 'indieStart投票管理'},
            children: [
                {
                    path: 'vote',
                    component: () => import('@/views/operation/indieStar/vote/list'),
                    meta: {title: 'indieStart投票管理列表'}
                },
            ]
        },
        //短信管理
        {
            path: 'notify',
            component: () => import('@/components/RouterView'),
            redirect: '/operation/notify/list',
            meta: { title: '短信通知'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/operation/notify/list'),
                    meta: {title: '短信通知列表'}
                },
            ]
        },
		//经营平台公告
		{
		    path: 'fbnotices',
		    component: () => import('@/components/RouterView'),
		    redirect: '/operation/fbnotices/list',
		    meta: { title: '经营平台公告'},
		    children: [
		        {
		            path: 'list',
		            component: () => import('@/views/operation/fbnotices/list'),
					meta: {title: '经营平台公告列表', activePage: '/operation/fbnotices'}
		        },
		    ]
		},
		//推送管理
		{
		    path: 'pushManage',
		    component: () => import('@/components/RouterView'),
		    redirect: '/operation/pushManage',
		    meta: { title: '推送管理'},
		    children: [
		        {
		            path: '',
		            component: () => import('@/views/operation/pushManage'),
		            meta: {title: '推送管理列表'}
		        },
		        {
		            path: 'edit/:id',
		            component: () => import('@/views/operation/pushManage/edit'),
		            meta: {title: '推送管理详情'},
		            props: true
		        },
		    ]
		}, 
		//口令管理passcode
		{
			path: 'passCode',
			component: () => import('@/components/RouterView'),
			redirect: '/operation/passCode',
			meta: { title: '口令管理'},
			children: [
				{
					path: '',
					component: () => import('@/views/operation/passCode'),
					meta: {title: '口令管理列表'}
				},
				{
					path: 'edit/:id',
					component: () => import('@/views/operation/passCode/edit'),
					meta: {title: '口令管理详情'},
					props: true
				},
			]
		},
		//客服工作台
		{
		    path: 'service',
		    component: () => import('@/components/RouterView'),
		    redirect: '/operation/service/list',
		    meta: { title: '客服工作台'},
		    children: [
		        {
		            path: 'list',
		            component: () => import('@/views/operation/service/list'),
		            meta: {title: '客服工作台'}
		        },
		    ]
		},
		//调查问卷
		{
		    path: 'survey',
		    component: () => import('@/components/RouterView'),
		    redirect: '/operation/survey/list',
		    meta: { title: '调查问卷'},
		    children: [
		        {
		            path: 'list',
		            component: () => import('@/views/operation/survey/index.vue'),
		            meta: {title: '调查问卷列表', activePage: '/operation/survey'}
		        },
				{
				    path: 'detail/:id',
				    component: () => import('@/views/operation/survey/detail.vue'),
				    meta: {title: '编辑问卷', activePage: '/operation/survey'},
					props: true
				},
				{
				    path: 'add',
				    component: () => import('@/views/operation/survey/detail.vue'),
				    meta: {title: '创建问卷', activePage: '/operation/survey'}
				},
				{
				    path: 'datalist/:id/:name',
				    component: () => import('@/views/operation/survey/datalist.vue'),
				    meta: {title: '数据统计', activePage: '/operation/survey'},
					props: true
				}
		    ]
		},
		// 积分商品
        {
            path: 'pointsGoods',
            component: () => import('@/components/RouterView'),
		    redirect: '/operation/pointsGoods/list',
		    meta: { title: '积分商品'},
            children: [
                {
		            path: 'list',
		            component: () => import('@/views/operation/pointsGoods/list/index.vue'),
		            meta: {title: '积分商品列表'}
		        },
                {
                    path: 'edit/:id',
                    component: () => import('@/views/operation/pointsGoods/edit/index.vue'),
                    meta: {title: '编辑积分商品'},
                    props: true
                },
                {
                    path: 'add',
                    component: () => import('@/views/operation/pointsGoods/edit/index.vue'),
                    meta: {title: '创建积分商品'}
                }
            ]
        },
		// 关键词		
		{
			path: 'keywords',
			component: () => import('@/components/RouterView'),
			redirect: '/operation/keywords/list',
			meta: {title: '关键词'},
			children: [
				{
					path: 'list',
					component: () => import('@/views/operation/keywords/list.vue'),
					meta: {title: '关键词列表'}
				}
			]
		},
        // 首页活动入口管理
        {
            path: 'homeEventConfig',
            component: () => import('@/components/RouterView'),
		    redirect: '/operation/homeEventConfig/list',
		    meta: { title: '首页活动入口管理'},
            children: [
                {
		            path: 'list',
		            component: () => import('@/views/operation/homeEventConfig/list/index.vue'),
		            meta: {title: '首页活动入口'}
		        },
                {
                    path: 'edit/:id',
                    component: () => import('@/views/operation/homeEventConfig/edit/index.vue'),
                    meta: {title: '编辑活动入口'},
                    props: true
                },
                {
                    path: 'add',
                    component: () => import('@/views/operation/homeEventConfig/edit/index.vue'),
                    meta: {title: '创建活动入口'}
                }
            ]
        },
		//语音包管理
		{
		    path: 'voice',
		    component: () => import('@/components/RouterView'),
		    redirect: '/operation/voice',
		    meta: { title: '语音包管理'},
		    children: [
		        {
		            path: '',
		            component: () => import('@/views/operation/voice'),
		            meta: {title: '语音包管理列表'}
		        },
		        
		    ]
		},
		
		// 短信营销管理
		{
		    path: 'message',
		    component: () => import('@/components/RouterView'),
		    redirect: '/operation/message/list',
		    meta: { title: '短信营销'},
		    children: [
		        {
		            path: 'list',
		            component: () => import('@/views/operation/message/list.vue'),
		            meta: {title: '短信营销列表'}
		        },{
                    path: 'statistics/:id',
                    component: () => import('@/views/operation/message/statistics.vue'),
                    meta: {title: '短信营销数据'}
                },
		    ]
		},
        //专题管理
        {
            path: 'special',
            component: () => import('@/components/RouterView'),
            redirect: '/operation/special/list',
            meta: {title: '专题管理'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/operation/special/list/index.vue'),
                    meta: {title: '专题列表'}
                },
                {
                    path: 'add',
                    component: () => import('@/views/operation/special/edit/step1.vue'),
                    meta: {title: '新增专题'}
                },
                {
                    path: 'edit/step1/:id',
                    component: () => import('@/views/operation/special/edit/step1.vue'),
                    meta: {title: '编辑专题'},
                    props: true
                },
                {
                    path: 'edit/step2/:id',
                    component: () => import('@/views/operation/special/edit/step2.vue'),
                    meta: {title: '绑定演出'},
                    props: true
                },{
                    path: 'statistics/:id',
                    component: () => import('@/views/operation/special/statistics.vue'),
                    meta: {title: '专题数据'}
                },
            ]
        },
        // 春苗计划
        {
            path: 'springSeed',
            component: () => import('@/components/RouterView'),
            redirect: '/operation/springSeed/list',
            meta: {title: '春苗计划'},
            children: [
                {
                    path: 'list',
                    component: () => import('@/views/operation/springSeed/list.vue'),
                    meta: {title: '春苗计划列表'}
                },
            ]
        },
    ]
};
